import React from 'react';

import { AppleAuthResponse } from '@Store/auth/auth.types';
import { noop } from '@Utils/util';

const APPLE_SCRIPT_SRC = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';

type AppleLoginProps = {
  clientId: string;
  scope: string;
  redirectURI: string;
  usePopup?: boolean;
  callback?: (payload: AppleAuthResponse) => void;
  onError?: (err: string) => void;
};

const AppleLogin: React.FC<AppleLoginProps> = ({
  scope,
  callback = noop,
  onError = noop,
  clientId,
  usePopup,
  redirectURI,
}) => {
  React.useEffect(() => {
    if (document.querySelector(`script[src="${APPLE_SCRIPT_SRC}"]`)) {
      return;
    }

    const script = document.createElement('script');
    script.src = APPLE_SCRIPT_SRC;
    script.async = true;
    document.body.appendChild(script);
  }, []);

  const handleClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      window.AppleID.auth.init({ clientId, scope, redirectURI, usePopup });
      const response = await window.AppleID.auth.signIn();
      callback(response);
      return response;
    } catch (err) {
      // @ts-expect-error undocumented error type
      onError(err);
      return undefined;
    }
  };

  return <button type="button" aria-label="button" onClick={handleClick} />;
};

export default AppleLogin;
